


















































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class DeleteUserDialog extends Vue {
  @Prop() user!: any;
  @Prop() dialogDelete!: boolean;

  loadingDelete = false;
  snackbarSuccessDelete = false;
  snackbarErrorDelete = false;

  private cancelDelete(): void {
    this.$emit("cancelDelete");
  }

  private removeUser(): void {
    this.loadingDelete = true;
    this.$store
      .dispatch("user/deleteUser", this.user.userId)
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessDelete = true;
        } else {
          this.snackbarErrorDelete = true;
        }

        this.loadingDelete = false;
        this.$emit("cancelDelete");
      });
  }
}
